import { call, put } from 'redux-saga/effects';
import api from '../../services/api';

import { Creators as PrivacyPolicyCreators } from '../ducks/privacyPolicy';

export function* getPrivacyPolicy() {
  const response = yield call(api.get, 'v1/sites/privacy_policy');
  if (response.ok) {
    yield put(PrivacyPolicyCreators.getPrivacyPolicySuccess(response.data.privacy_policy));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/privacyPolicy.js